import { ControlResponseOptionsType } from './types';

export const CONTROL_RESPONSE_OPTIONS: ControlResponseOptionsType = [
  {
    id: 'resist',
    title: 'I resist — I need to stay in charge',
  },
  {
    id: 'depends',
    title: "Depends on who's giving the orders",
  },
  {
    id: 'secretly_like',
    title: 'I secretly like it when someone takes control',
  },
  {
    id: 'obey',
    title: "Tell me what to do and I'll obey",
  },
];
